import React, { useState } from "react";
import { Icon } from "antd";
import {
	answerTypeTexts,
	backendTypeToAnswerType,
} from "../../../../constants/answerType";
import Result from "./result";
import {
	getQuestionFile,
	getQuestionFilePreview,
} from "../../../../store/thunks/get-file";
import { ChevronDownIcon } from "../../../../../../resource/icons";
import Attachment from "../../../../components/attachments/attachment";

const QuestionResult = ({ question, results }) => {
	const [filesOpened, openFiles] = useState(false);
	const hereAreSomeFiles = !!question.files?.length;

	return (
		<div className="question" key={question.id}>
			<div className="header">
				{question.text ? (
					<div className="title">
						<span>
							{question.text}
							{question.obligatory ? (
								<>
									&nbsp;
									<Icon type="star" className="obligatory" theme="filled" />
								</>
							) : (
								""
							)}
						</span>
					</div>
				) : (
					<div className="title-placeholder">Вопрос без текста</div>
				)}

				<div className="question-type">
					{answerTypeTexts[backendTypeToAnswerType[question.type.id]]}
				</div>
			</div>
			{hereAreSomeFiles && (
				<div
					className="show-more show-more-question"
					onClick={() => openFiles(!filesOpened)}
				>
					<span className="text">Вложения</span>
					<ChevronDownIcon className={filesOpened && "chevron-opened"} />
				</div>
			)}
			{filesOpened && hereAreSomeFiles && (
				<div className="attachments">
					{question.files.map((file, index) => {
						return (
							<Attachment
								popup
								key={index}
								getFile={() => {
									return getQuestionFile(question.id, file.fileName);
								}}
								uploadedFileText={file.name}
								loadPreview={() => {
									return getQuestionFilePreview(question.id, file.fileName);
								}}
							/>
						);
					})}
				</div>
			)}

			{results
				.filter((result) => result.questionId === question.id)
				.map((result) => {
					return (
						<Result result={result} question={question} key={result.itemText} />
					);
				})}
		</div>
	);
};

export default QuestionResult;
